import Vue from 'vue'
import Store from 'store'

import CheckoutBillingInfo from './CheckoutBillingInfo.vue'

const el = '.nti-component--checkout-billing'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        const action = DOM.dataset.action
        new Vue({
            store: Store,
            el,
            components:{
                CheckoutBillingInfo
            },
            template: `<CheckoutBillingInfo action="${action}" />`
        })
    }
}

export default {
    render
}